import Backbone from 'backbone'
import template from './select-destination-metrics-dialog.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import SelectedItemInfo from './selected-item-info'

const SelectDestinationMetricsDialog = Backbone.View.extend({

	className: 'select-destination-metrics-dialog vi-destination-items',

	events: {
		'click .cancel': 'done',
		'click .delete': 'removeItem',
		'click .delete-all': 'removeAllItems'
	},

	initialize: function(options = {}) {
		this.options = options
		this.destinationItems = this.options.destinationItems ||[]
		this.sourceNameTotal = this.options.sourceNameTotal || 0
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.renderSelectedItemInfo()
		return this
	},

	renderSelectedItemInfo: function() {
		let selectedItemInfo = new SelectedItemInfo({
			type: this.options.type,
			numSourceItems: this.options.numSourceItems,
			numDestinationItems:this.destinationItems.length
		})
		// #57395 - for SelectedItemInfo, it appears that we need call render()
		// before replacing with the el, or it doesn't display on subsequent
		// calls to this method
		selectedItemInfo.render()
		this.$('.selected-item-info').replaceWith(selectedItemInfo.el)

	},

	removeItem: function(e) {
		var node = this.$(e.target).closest('tr')
		var id = this.$(e.target).data('id')

		_.remove(this.destinationItems, item => item.id === id)

		node.remove()
		this.renderSelectedItemInfo()
		this.trigger('change', id)
		this.noneSelectedMessageDisplay()
	},

	removeAllItems: function(e) {
		this.destinationItems = []
		this.renderSelectedItemInfo()
		this.trigger('change')
		this.noneSelectedMessageDisplay()
	},

	noneSelectedMessageDisplay: function() {
		// if no items are selected, hide the table and display the message
		// (we don't have a way toggle it back because you can only remove items
		// in this dialog) (#32520)
		if (this.destinationItems.length == 0) {
			this.$('.table').addClass('is-not-displayed')
			this.$('.no-measures').removeClass('is-not-displayed')
		}
	},

	context: function () {
		let type = this.options.type
		let singularKey, pluralKey, instructionsKey
		if (type === 'initiative-status') {
			singularKey = 'initiatives.initiative'
			pluralKey = 'initiatives.initiatives'
			instructionsKey = 'admin.import.selectItems.instructions.initiative'
		} else {
			singularKey = 'scorecards.node.metric'
			pluralKey = 'scorecards.metrics.metrics'
			instructionsKey = 'admin.import.selectItems.instructions.metric'
		}
		let singularItem = i18n.get(singularKey)
		let pluralItem = i18n.get(pluralKey)

		return {
			destinationItems: this.destinationItems,
			title: i18n.get('admin.import.selectItems', pluralItem),
			panelHeader: i18n.get('admin.import.selectItems.itemsToMap', pluralItem),
			itemColumnHeader: i18n.get('admin.import.selectItems.itemName', singularItem),
			instructions: i18n.get(instructionsKey)
		}
	},

	done: function() {
		var data = {
			destinationItems: this.destinationItems // for now
		}

		this.trigger('done', data)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

export default SelectDestinationMetricsDialog
SelectDestinationMetricsDialog.__filename__ = 'imports/vi/select-destination-metrics-dialog.js'
